module.exports = __webpack_public_path__ + "img/yaocai.26cb87cf.png";